import IComponent from "components/commons/IComponent";
import MiniPanel from "components/commons/MiniPanel";
import OpacitySlider from "components/LayerSetting/OpacitySlider";
import SwitchButton from "components/commons/SwitchButton";
import LayerDropDown from "components/LayerSetting/LayerDropDown";
import Button from "@material-ui/core/Button";
import LayerToggleUtil from "utils/LayerToggleUtil";
import { Fragment } from "react";
import BookmarkUtils from "utils/BookmarkUtils";

import { Checkbox, FormControlLabel } from "@material-ui/core";

const SHORT_CUT_LAYERS_TITLE = ["Man Made Slope", "Ortho Photo"];
const SHORT_CUT_3D_LAYERS = {
  "LandsD - 3D Spatial Dataset": ["LandsD 3D Bldg", "LandsD 3D Infra"],
};
let cachedMultiLevelDef = {};

let list = [
  { type: "Unclassifed", checked: true },
  { type: "Low vegetation", checked: true },
  { type: "High vegetation", checked: true },
  { type: "Transmission tower", checked: true },
  { type: "Ground", checked: true },
  { type: "Medium vegetation", checked: true },
  { type: "Building", checked: true },
];
class ShortcutLayerList extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      randomseed: Math.random(),
      pointCloudClass: false,
    };
  }
  componentWillMount() {}

  componentDidMount() {}

  isAnyLayerAdded(category, tag) {
    let layerList = this.$config.mapList;
    return layerList.layer3D[category].some((i) =>
      tag ? i.tags.some((t) => t == tag) && !!i.layer : !!i.layer
    );
  }

  render3dShortcutList(config3DLayerCategryObj, categry) {
    return config3DLayerCategryObj.map((lyrDataObj) => {
      let isCategory = typeof lyrDataObj === "string";
      let isenabled = isCategory
        ? this.isAnyLayerAdded(categry, lyrDataObj)
        : lyrDataObj.enabled;
      return (
        <Fragment>
          <div className="SubPanelContent">
            <SwitchButton
              label={lyrDataObj.title}
              placeAtRight={true}
              // checked={lyrDataObj.layer?.visible}
              checked={isenabled}
              onClick={() => {
                let tmpTimeout = setTimeout(() => {
                  this.props.showDialog({ isOpen: false });
                  clearTimeout(tmpTimeout);
                  tmpTimeout = null;
                }, 10);
                LayerToggleUtil.toggle3DLayer(
                  categry,
                  lyrDataObj,
                  undefined,
                  this.props.mapView,
                  this.props.isSecondMap,
                  true
                );
              }}
            />
          </div>

          {lyrDataObj.layer && lyrDataObj.layer.visible && (
            <OpacitySlider layer={lyrDataObj.layer} />
          )}
        </Fragment>
      );
    });
  }

  makeMultiLevelLut(layer) {
    if (cachedMultiLevelDef[layer.id]) return cachedMultiLevelDef[layer.id];
    var output = layer.allSublayers
      .map((i) => [i, i.title, i.parent.title])
      .sort((a, b) => a[0].id - b[0].id)
      .reduce((p, c, i) => {
        if (!(c[2] in p)) p[c[2]] = [];
        p[c[2]].push({
          layer: c[0],
          title: c[1],
          parent: c[2],
        });
        return p;
      }, {});
    console.debug(output);
    if (Object.keys(output).lenght > 0) cachedMultiLevelDef[layer.id] = output;
    return output;
  }

  render() {
    let layerList = this.$config.mapList;

    let lyrList = layerList["overlays"].filter((lyr) =>
      SHORT_CUT_LAYERS_TITLE.includes(lyr.title)
    );

    let all2DLayers = layerList.layer2D;

    let vm = this;
    return (
      <div
        key={this.state.randomseed}
        className="ShortcutLayerlistPanel"
        style={{ width: "300px", background: "white" }}
      >
        {lyrList.map((lyrData, index) => {
          let l = lyrData.layer;

          return (
            <MiniPanel
              collapsed={!l.visible}
              titleClass="ListTitle"
              titleText={
                <SwitchButton
                  label={l.title || <i>Loading...</i>}
                  placeAtRight={true}
                  checked={l.visible}
                  onClick={() => {
                    let tmpTimeout = setTimeout(() => {
                      vm.props.showDialog({ isOpen: false });
                      clearTimeout(tmpTimeout);
                      tmpTimeout = null;
                    }, 10);

                    l.visible = !l.visible;

                    // link to state of overlay of man-made feature
                    if (
                      l.title === "Man Made Slope" &&
                      all2DLayers.some((i) => i.layer.visible) == true
                    ) {
                      let layer2DIdx = all2DLayers.findIndex(
                        (i) => i.layer.visible
                      );
                      console.log(layer2DIdx);
                      layer2DIdx = layer2DIdx == -1 ? undefined : layer2DIdx;
                      let layer = all2DLayers?.[layer2DIdx]?.layer;
                      let MMS = this.makeMultiLevelLut(layer)[
                        "Slope and Catchment"
                      ]?.filter((l) => l.title === "Man-made Features");
                      if (MMS) {
                        MMS[0].layer.visible = l.visible;
                      }

                      let MMS_2 = this.makeMultiLevelLut(layer)[
                        "Slope"
                      ]?.filter((l) => l.title === "Man-made Features");
                      if (MMS_2) {
                        MMS_2[0].layer.visible = l.visible;
                      }

                      let SI = this.makeMultiLevelLut(layer)[
                        "Annotation"
                      ]?.filter((l) => l.title === "Slope Features");

                      if (SI) {
                        SI[0].layer.visible = l.visible;
                      }
                    }

                    vm.setState({});
                  }}
                  style={{ width: "22px" }}
                />
              }
            >
              {lyrData.lyType == "group" && (
                <div className="SubPanelContent">
                  <LayerDropDown
                    layers={lyrData.layer.layers}
                    activeLayer={lyrData.activeLayer || 0}
                    onChange={(e) => {
                      let tmpTimeout = setTimeout(() => {
                        vm.props.showDialog({ isOpen: false });
                        clearTimeout(tmpTimeout);
                        tmpTimeout = null;
                      }, 10);

                      lyrData.activeLayer = e;
                      lyrData.layer.layers.forEach((lyr, i) => {
                        lyr.visible = i === e;
                      });
                      vm.setState({});
                    }}
                  />
                </div>
              )}
              {lyrData.transparency && <OpacitySlider layer={l} />}
              {l.title === "Man Made Slope" && (
                <SwitchButton
                  label={"Filled Symbology"}
                  checked={!l.findSublayerById(44)?.renderer}
                  onClick={() => {
                    l.findSublayerById(44).renderer = !l.findSublayerById(44)
                      ?.renderer
                      ? this.$config.SLOPE_RENDERER
                      : null;
                    vm.setState({});
                  }}
                  style={{ width: "22px" }}
                />
              )}
            </MiniPanel>
          );
        })}

        {Object.keys(SHORT_CUT_3D_LAYERS).map((categry) => {
          let config3DLayerCategryObj = layerList["layer3D"][categry];

          if (config3DLayerCategryObj) {
            return (
              vm.props.is3D && (
                <MiniPanel titleText={categry} titleClass="SubPanelContent">
                  {vm.render3dShortcutList(config3DLayerCategryObj, categry)}
                </MiniPanel>
              )
            );
          }
        })}

        <div className="panelTitle ListTitle " style={{ textAlign: "center" }}>
          <Button
            color="primary"
            variant="contained"
            style={{
              width: "100%",
              height: "100%",
            }}
            onClick={() => {
              let defaultLayerClone = this.$config.DEFAULT_LAYERS[
                `${this.props.mapType}D_OBJ`
              ];
              BookmarkUtils.fromJson(this.props.mapView, defaultLayerClone);

              // link to state of overlay of man-made feature
              lyrList.map((lyrData, index) => {
                let l = lyrData.layer;
                if (
                  l.title === "Man Made Slope" &&
                  all2DLayers.some((i) => i.layer.visible) == true
                ) {
                  let layer2DIdx = all2DLayers.findIndex(
                    (i) => i.layer.visible
                  );
                  console.log(layer2DIdx);
                  layer2DIdx = layer2DIdx == -1 ? undefined : layer2DIdx;
                  let layer = all2DLayers?.[layer2DIdx]?.layer;
                  let MMS = this.makeMultiLevelLut(layer)[
                    "Slope and Catchment"
                  ]?.filter((l) => l.title === "Man-made Features");
                  if (MMS) {
                    MMS[0].layer.visible = true;
                  }

                  let MMS_2 = this.makeMultiLevelLut(layer)["Slope"]?.filter(
                    (l) => l.title === "Man-made Features"
                  );
                  if (MMS_2) {
                    MMS_2[0].layer.visible = l.visible;
                  }

                  let SI = this.makeMultiLevelLut(layer)["Annotation"]?.filter(
                    (l) => l.title === "Slope Features"
                  );

                  if (SI) {
                    SI[0].layer.visible = true;
                  }
                }
              });

              this.props.showDialog({ isOpen: false });
            }}
          >
            Reset to default
          </Button>
        </div>
        {false && (
          <MiniPanel
            collapsed={false}
            titleClass="ListTitle"
            titleText={
              <SwitchButton
                label={"Point Cloud Classes" || <i>Loading...</i>}
                placeAtRight={true}
                checked={this.state.pointCloudClass}
                onClick={() => {
                  let tmpTimeout = setTimeout(() => {
                    vm.props.showDialog({ isOpen: false });
                    clearTimeout(tmpTimeout);
                    tmpTimeout = null;
                  }, 10);
                  this.setState({
                    pointCloudClass: !this.state.pointCloudClass,
                  });
                  vm.setState({});
                }}
                style={{ width: "22px" }}
              />
            }
          >
            {this.state.pointCloudClass && (
              <div style={{ display: "grid", marginLeft: "20px" }}>
                {list.map((i) => (
                  <FormControlLabel
                    key={`${Math.random()}`}
                    value={i.type}
                    style={this.props.compact ? { height: "25px" } : undefined}
                    control={
                      <Checkbox
                        key={`${Math.random()}`}
                        checked={i.checked}
                        onChange={(e) => {
                          i.checked = !i.checked;
                          // currentValue.checked = !currentValue.checked;
                          this.setState({});
                          this.props.onChange && this.props.onChange();
                        }}
                        color="primary"
                      />
                    }
                    label={i.type}
                    labelPlacement="end"
                  />
                ))}
              </div>
            )}
          </MiniPanel>
        )}
      </div>
    );
  }
}

export default ShortcutLayerList;
